<template>
  <div class="Traincourse">
    <div class="introduce">
      <h1>生涯规划咨询师课程介绍</h1>
      <img src="../../assets/image/course/img1.png" alt="" style="width:60%" />
      <p>
        生涯规划咨询师课程是针对生涯规划咨询师课体系制作的教学培训课程，由生涯规划咨询师平台制作并上传，主要用于生涯规划咨询师考生的考前知识培训，课程内容包括：5个板块（理念篇、认知篇、规划篇、储备篇、进阶篇）的课程教学，考生可通过课程的培训学习来提高自身的生涯规划能力，以此保证通过考试。生涯规划咨询师平台建议考生先学习课程，再通过模拟练习打磨知识，最后再参加正式考试，从而顺利的获得证书！
      </p>
      <el-button @click="joincourse">立即参加课程培训</el-button>
    </div>
    <h1 class="text-center">课程介绍</h1>

    <div class="introduce_top">
      <img src="../../assets/image/course/img2.png" alt="" style="width:80%" />
      <div class="introduce_bg">
        <div class="card flex">
          <img
            src="../../assets/image/course/01.png"
            alt=""
            width="28"
            height="35"
            style="padding-right:10px"
          />
          <p>
            生涯规划咨询师课程是针对生涯规划咨询师评测体系制作的教学培训课程，由生涯规划咨询师平台邀请名师制作，主要用于生涯规划咨询师考生的考前知识培训。
          </p>
        </div>
        <div class="card flex">
          <img
            src="../../assets/image/course/02.png"
            alt=""
            width="28"
            height="35"
            style="padding-right:10px"
          />
          <p>
            课程内容包括：5个板块（理念篇、认知篇、规划篇、储备篇、进阶篇），共十二节的课程教学，考生可通过课程的培训学习来提高自身的网络教学能力，以此来保证通过考试。
          </p>
        </div>
      </div>
    </div>

    <div class="introduce">
      <h1 class="text-center">
        生涯规划咨询师<span style="color:#ff462a">核心技能</span>
      </h1>
      <b class="button">知识能力</b>
      <p>
        需要熟悉国家的教育政策、高等教育招生制度，了解各大学的专业设置和特色等
      </p>
      <b class="button">沟通能力</b>
      <p>
        能够与学生建立良好的沟通关系，听取他们的需求和想法，并对他们进行有针对性的学业及职业指导
      </p>
      <b class="button">心理学</b>
      <p>
        具有社会心理学和组织心理学、传播学的相关基础，知道人群个体差距和心理差异，以便更好解决问题
      </p>
      <img src="../../assets/image/course/img3.png" alt="" style="width:60%" />
      <br />
    </div>

    <div class="introduce_feature">
      <div class="introduce">
        <h1 style="color:#fff">
          生涯规划咨询师课程特色
        </h1>
        <div class="box ">
          <div
            class="item feature_container"
            v-for="(item, i) in list"
            :key="i"
            :style="{
              background: 'url(' + item.url + ')',
              'background-repeat': 'no-repeat',
              'background-size': '100% 100%',
              width: '23%',
              height: '250px',
              display: 'inline-block',
            }"
          >
            <div class="feature">
              <h3>{{ item.title }}</h3>
              <span v-html="item.content"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="why">
      <h1 class="text-center">
        为什么<span style="color:#ff462a">先学习课程</span>
      </h1>
      <br />
      <div class="why_con">
        <div class="text-center why_l" style="width:100%;">
          <b>助力您成为生涯规划师</b>
          <br />
          <br />
          <el-button size="mini" type="warning" plain @click="joincourse"
            >立即参加培训课程</el-button
          >
          <br />
          <br />
        </div>
      </div>
      <div class="why_r">
        <br />
        <ul>
          <li>
            因为生涯规划咨询师评测体系是检验学员是否已经具备了对来访者进行生涯规划指导的能力，所以评测的内容及知识比较繁多，要求学员熟练掌握知识才可通过评测。
          </li>
          <br />
          <li>
            生涯规划师平台建议学员先学习生涯规划课程和参加模拟练习后再前往正式考试。
          </li>
        </ul>
        <br />
      </div>
    </div>
  </div>
</template>
<script>
let _this
export default {
  data() {
    return {
      list: [
        {
          url: require('../../assets/image/course/img8.png'),
          title: '理论体系化',
          content: '专业系统理论学习<br/>掌握生涯规划咨询师方法论',
        },
        {
          url: require('../../assets/image/course/img7.png'),
          title: '实践案例化',
          content: '结合案例实操演练<br/>吸取行业先进经验',
        },
        {
          url: require('../../assets/image/course/img6.png'),
          title: '讲师专业化',
          content: '国内知名生涯规划教育<br/>专家领衔专业讲师团队',
        },
        {
          url: require('../../assets/image/course/img5.png'),
          title: '培训标准化',
          content: '教学方法标准化<br/>以提高培训教学效果',
        },
      ],
    }
  },
  created() {
    this.user = localStorage.getItem('wps_user')
  },
  mounted() {
    this.oftop = document.getElementsByClassName('el-tabs__header is-left')[0]
    window.addEventListener('scroll', this.handleScrollx)
  },
  methods: {
    joincourse(id) {
      if (this.user) {
        this.$router.push({
          path: '/course',
          // path: '/course/' + this.$router.app._route.params.id,
        })
      } else {
        this.$message.warning('您还未登录，请先登录！')
        this.$router.push({ name: 'MLogin' })
      }
    },
  },
}
</script>
<style lang="less" scoped>
h1 {
  font-size: 22px;
  margin: 20px;
}
p {
  text-align: left;
  font-size: 14px;
  color: #666;
  line-height: 24px;
}
.introduce {
  width: 100%;
  text-align: center;
  padding: 20px 0px;
  p {
    width: 85vw;
    margin: 10px auto 20px;
  }
  .el-button {
    padding: 10px;
    background: #fd4a29;
    border-radius: 4px;
    color: #ffffff;
    border: none;
  }
}
.introduce_top {
  text-align: center;
  background: #fffcf9;
  .introduce_bg {
    background: url('../../assets/image/course/m_bg.png');
    background-size: 100% 100%;
  }
  .card {
    background-color: #fff;
    padding: 20px;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    margin: 25px;
    border-radius: 10px;
  }
}
.button {
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
  display: inline-block;
  padding: 5px 15px;
  border-radius: 6px;
  color: #fd4a29;
  font-size: 14px;
}
.introduce_feature {
  background: linear-gradient(to right, #ff9b5f 0%, #ff7a54 100%);
}
.box {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-start;
}

.item {
  flex: 1;
  height: 200px;
  min-width: calc((100% - 10px) / 2);
}
.feature_container {
  position: relative;
  h3 {
    color: #fd4a29;
  }
  p {
    font-size: 12px;
  }
}
.feature {
  position: absolute;
  bottom: 25px;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
  span {
    font-size: 12px;
  }
}
.why {
  padding: 20px 0 50px 0;
  background: #fefefe;
}
.why_con {
  width: 80%;
  margin: 0 auto;
  position: relative;
}
.why_con div:nth-child(1) {
  background-color: #fd4a29;
  color: #fff;
  font-size: 21px;
}

ul li::marker {
  background-color: #fd4a29 !important;
}
.why_l {
  padding-top: 16px;
}
.why_r {
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.03);
  font-size: 14px;
  width: 80%;
  margin: 0 auto;
  color: #666;
  line-height: 24px;
  background: #fff;
}
.why_bg {
  position: absolute;
  right: -150px;
  bottom: -140px;
  width: 260px;
}
</style>
